module.exports = __webpack_public_path__ + "images/jdcqssc.66b9.png";